import {
  CompanyDocumentAnalyticsRecordFragment,
  CompanyDocumentReadConfirmationType,
} from "gql/graphql";

export enum ParticipantStatus {
  SignedDigital = "SignedDigital",
  Reviewed = "Reviewed",
  AwaitingSignature = "AwaitingSignature",
  NotReviewed = "NotReviewed",
  NotRequired = "NotRequired",
}

export function getParticipantStatus(
  record: Pick<
    CompanyDocumentAnalyticsRecordFragment,
    "confirmDate" | "signedFile"
  >,
  readConfirmationType: CompanyDocumentReadConfirmationType | undefined,
): ParticipantStatus {
  if (record.signedFile) {
    return ParticipantStatus.SignedDigital;
  }

  if (record.confirmDate) {
    return ParticipantStatus.Reviewed;
  }

  if (
    readConfirmationType === CompanyDocumentReadConfirmationType.NotRequired
  ) {
    return ParticipantStatus.NotRequired;
  }

  if (
    readConfirmationType ===
    CompanyDocumentReadConfirmationType.DigitalSignature
  ) {
    return ParticipantStatus.AwaitingSignature;
  }

  return ParticipantStatus.NotReviewed;
}
